import { render } from "./TestTaking.vue?vue&type=template&id=341b9534&scoped=true"
import script from "./TestTaking.vue?vue&type=script&lang=js"
export * from "./TestTaking.vue?vue&type=script&lang=js"

import "./TestTaking.vue?vue&type=style&index=0&id=341b9534&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341b9534"]])

export default __exports__